// Enum → Mongolian labels for the tenant bank-account screen (Phase A "Данс").
import type { BankAccountPurpose } from "../apis/account";

export const PURPOSE_LABELS: Record<BankAccountPurpose, string> = {
  RECEIVE: "Орлого хүлээн авах",
  PAY    : "Төлбөр төлөх",
  BOTH   : "Хоёулаа"
};

export const PURPOSE_COLORS: Record<BankAccountPurpose, string> = {
  RECEIVE: "teal",
  PAY    : "blue",
  BOTH   : "grape"
};

export const purposeLabel = (p: string | null | undefined): string =>
  p == null ? "—" : PURPOSE_LABELS[p as BankAccountPurpose] ?? p;

export const verifiedLabel = (v: boolean): string => (v ? "Баталгаажсан" : "Хүлээгдэж буй");
export const activeLabel = (v: boolean): string => (v ? "Идэвхтэй" : "Идэвхгүй");
